import React from 'react'

import { staticAsset } from '@js/common/utils'

const SearchResultsSkeleton = ({ itemNumber = 6 }) => {
  const assetPath = 'images/sections/house/card-skeleton-v2.svg'

  const items = Array.from({ length: itemNumber }, (_, index) => (
    <div
      className='[ f-c-ba-whi f-radius-card-large f-pos-rel f-m-a-020 ] SearchResults-item-house'
      key={`skeleton_item_${index}`}>
      <img
        className='SearchResults-item-skeleton'
        src={staticAsset(assetPath)}
        alt='Haus card loading'
      />
    </div>
  ))

  return (
    <div className='[ f-d-flr f-fl-wrap f-fl-jc-ce ] SearchResults-items'>
      {items}
    </div>
  )
}

export default SearchResultsSkeleton
